export const SET_SEARCH_PARAMS = "SET_SEARCH_PARAMS";
export const SET_ALL_CATEGORIES = 'SET_ALL_CATEGORIES'
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_SUBCATEGORY = "SET_SUBCATEGORY";
export const SET_PAGE_NAME = "SET_PAGE_NAME";
export const PASS_ALL_PRODUCTS_BREADCRUMB_FLAG = "PASS_ALL_PRODUCTS_BREADCRUMB_FLAG";